<template>
  <div class="apply_container">
    <div class="header_img">
      <img
        src="https://faststatic.ccnfgame.com/cos/vrshow/a2478bade007269fc0c7236a423bd5b9.jpg"
      />
    </div>
    <div class="content_wrap">
        {{ applyStaus }}
      <h3 class="reson_title title_meia" v-if="applyStaus==107">{{ '拒绝理由：'+reason }}</h3>
      <div class="form_wrap" v-if="applyStaus!=103&&applyStaus!=105">
        <div class="form_item">
          <van-field
            readonly
            clickable
            required
            label="媒体类型Media Type"
            :value="value"
            placeholder="请选择媒体类型"
            @click="showPicker = true"
          />

          <van-popup v-model="showPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="mediaTypeList"
              @cancel="showPicker = false"
              @confirm="onConfirm"
            />
          </van-popup>
        </div>
        <div class="form_item">
            <van-radio-group v-model="idCardType" v-if="!applyStaus">
                <van-radio name="1">护照PASSPORT</van-radio>
                <van-radio name="2">港澳通行证</van-radio>
            </van-radio-group>
        </div>
        <div class="form_item" >
          <div class="upload_wrap" v-if="!applyStaus">
            <span class="title_meia">人脸照片Face Photo</span>
            <van-uploader v-model="facePhoto" :after-read="afterReada" />
          </div>
          <div class="upload_wrap" v-if="!applyStaus">
            <span class="title_meia">{{ idCardType==1?'护照':'港澳通行证' }}图片PASSPORT</span>
            <van-uploader v-model="passport" :after-read="afterReadb" />
          </div>
          <van-cell-group>
            <van-field
              v-model="formData.goodName"
              required
              label="姓名Name"
              placeholder="请输入内容"
            />
            <van-field
              v-model="formData.idcardNumber"
              required
              label="护照号码 Passport No."
              placeholder="请输入内容"
              size="large"
            />
            <van-field
              v-model="formData.region"
              readonly
                clickable
                required
              label="地区Area"
              placeholder="请输入内容"
              @click="showCountry = true"
            />
            <van-field
              v-model="formData.companyUrl"
              required
              label="公司网址Website"
              placeholder="请输入内容"
            />
            <van-field
              v-model="formData.company"
              required
              label="公司名称Company"
              placeholder="请输入内容"
            />
            <van-field
              v-model="formData.companyPhone"
              required
              label="公司联系电话TEL."
              placeholder="请输入内容"
            />
            <van-field
              v-model="formData.mediaName"
              required
              label="媒体名称Media Name"
              placeholder="请输入内容"
            />
            <van-field
              v-model="formData.post"
              required
              label="职位TITLE"
              placeholder="请输入内容"
            />
            <van-field
              v-model="formData.email"
              required
              label="个人邮箱地址Email"
              placeholder="请输入内容"
            />
            <div class="upload_wrap">
                <span class="title_meia">请参考“媒体注册须知”申请条件对应媒体类型上传相关资料</span>
                <van-uploader v-model="pressCard" :after-read="afterReadc" />
            </div>
            <van-field
              v-model="formData.mobile"
              required
              label="手机号Mobile"
              placeholder="请输入内容"
            />
            <!-- <van-field
              v-model="formData.code"
              label="短信验证码MSG Code"
              placeholder="请输入内容"
            >
            <van-button slot="button" type="primary" size="middle" plain>
                获取验证码
                </van-button>
            </van-field> -->
          </van-cell-group>
        </div>
        <div class="tips_wrap">   
            <van-checkbox v-model="checked"></van-checkbox>
            <div class="desc">
                <span>我已认真阅读并知悉</span>
                <van-button type="primary"  @click="showTips=true">注册须知</van-button>
            </div>
        </div>
        <div class="form_item my_btn">
            <van-button type="info"  @click="handelSubmit">提交申请SUBMIT</van-button>
        </div>
      </div>
      <div class="qrcode_wrap" v-else>
        <h3 class="qr_name" v-if="applyStaus==105">{{ applyDetail.goodName }}</h3>
        <div class="box_show" v-if="applyStaus==103">
            <span>您的资料已提交，请耐心等待审核，审核通过后，我们将通过邮件通知您。</span>
        </div>
        <div class="box_show" v-if="applyStaus==105">
            <img :src="qrcodeUrl" alt="">
        </div>
      </div>
      <van-popup v-model="showCountry" position="bottom">
        <van-picker
            show-toolbar
            :columns="countryData"
            @cancel="showCountry = false"
            @confirm="onConfirmCountry"
        />
        </van-popup>
        <van-text-dialog
            :show="showTips"
            title="2023年第二十一届广州国际汽车展览会"
            :body="content"
            mask
            button-text="我已知悉"
            @confirm="comfirm"
            @close="close"
            @toggle="toggle"
            >
            </van-text-dialog>
    </div>
  </div>
</template>
<script>
import countryData from "@/common/js/countryData.json";
import QRcode from "qrcode";
import axios from 'axios';
import {
  checkCard,
  singleUserApply,
  login,
  resubmit
} from "@/common/api/media.js";
import { Toast } from 'vant-green';


export default {
  data() {
    return {
        // 107 拒绝 105 通过 103 审核中
      applyStaus:undefined,
      qrcodeUrl:'',
      reason:'',
      isApply: false,
      action: `https://vrhall.ccnfgame.com/oss/storage/uploadImg`,
      countryData,
      idCardType:"1",
      showTips:false,
      content:`（一）持有中华人民共和国新闻出版总署核发的，且在有效期内并具有2023年度核验标志的媒体证的相关人员。

（二）持有中国外交部签发的驻华常驻新闻媒体证的相关人员；外国驻华新闻媒体的中方雇员需持有关部门颁发的中方雇员证。

（三）持有外国政府核发的媒体证的人员需持有效护照和J-2签证。

（四）持有中华人民共和国新闻出版总署获准发行的出版物所核发的资格证明的相关人员（需要出示原件，复印件无效）。

（五）香港、澳门地区的记者需持有由中华全国新闻工作者协会制发的港澳记者采访证。

（六）能够出示电台、电视台工作证及采访广州车展公函原件的电台、电视台记者及制作公司人员。

（七）隶属新闻联合机构或出版公司的互联网出版物的有关人员；可以证明为相关在线出版物工作的有关人员；此互联网出版物需有相关的广州车展专题频道（需要出示证明函原件，复印件无效）。

（八）受正规报刊、电视台、电台委派的自由撰稿人、编辑及摄影记者，须提交带有委托单位抬头和公章的正式委托采访广州车展的函，证明其负责相关展会事宜（需要出示证明函原件，复印件无效），并提供其在书刊、杂志、网络上发表的相关汽车类文章截图、链接等。广告公司/传媒公司的委托函无效。

（九）以公司为主体运营的自媒体账号（包括但不限于网站、视频账号、客户端、微信公众号和新浪、腾讯微博形式进行宣传的媒体机构）的编辑及相关工作人员，需要上传公司派遣该员工参加广州车展报道的介绍信原件（需盖章且具名，复印件无效）、个人名片、有关汽车行业的宣传报道截图（需署名且包含阅读量或转载量）。

以个人为主体运营的自媒体账号（包括但不限于网站、视频账号、客户端、微信公众号和新浪、腾讯微博形式进行宣传的撰稿人个人），仅限账号运营者本人申请，需要提供该账号的运营证明（包括但不限于后台截图），并提供汽车相关内容阅读量/观看量证明（微博账号日阅读量超过5万，视频账号每条观看量超过2万，微信公众号单篇文章阅读量超过1万），其他可控数据如粉丝数、转发量等不在主办方审核范围之内，每个个人自媒体账号仅能申请一张证件。

（十）受参展汽车企业邀请的媒体人员需持有具名的邀请函原件（不具名的邀请函、复印件均无效）。参展汽车企业的邀请函必须写有受邀记者的姓名，并加盖企业公章。如参展汽车企业的邀请函采用电子邮件形式，则参展汽车企业必须向广州车展主办方提前提交所有邀请的媒体记者名单。凡由公关公司、广告公司等代理机构提交的名单，广州车展主办方不予受理。

（十一）本届广州汽车展的参展媒体（与组委会签署合作意向书的媒体单位）可以在官网“团体申请”通道凭组委会提供的密码进行团体申请。已进行“团体申请”的媒体从业人员不得再自行申请媒体证件。`,
      mediaTypeList: [
        {
            text:'报纸',
            id:"1"
        },
        {
            text:'杂志',
            id:"2"
        },
        {
            text:'网络',
            id:"3"
        },
        {
            text:'电视台',
            id:"4"
        },
        {
            text:'电台',
            id:"5"
        },
        {
            text:'自媒体',
            id:"6"
        },
        {
            text:'其他',
            id:"10"
        },
      ],
      value: "",
      showPicker: false,
      showCountry:false,
      defaultValue: "",
      fileList: [],
      checked:true,
      pressCard:[],
      pressCardUrlList:[],
      passport:[],
      facePhoto:[],
      formData:{
        address: "",
        agency: "",
        areaId: "",
        backPhoto: "",
        birth: "2020-11",
        cityId: "",
        code: "882288",
        company: "",
        companyEmail: "",
        companyLogo: "https://apps-1255573444.cos.ap-guangzhou.myqcloud.com/zhanhui/1677641467782.jpg",
        companyPhone: "",
        companyUrl: "",
        countryId: "",
        dataId: "",
        email: "",
        expireEnd:"2020-11-11 00:00:00",
        expireStart: "2020-11-11 00:00:00",
        facePhoto: "",
        frontPhoto: "",
        gender: "",
        goodName: "",
        idCardType: "1",
        idcardNumber: "",
        location: "",
        mediaName: "",
        mobile: "",
        nation: "",
        orderId: "1711272035105398785",
        // orderId:"1580478394959732737",
        passport: "",
        post: "",
        pressCard: "",//资料
        provinceId: "",
        region: "",
        // voucherId: "1603782833241899010",
        // voucherIds: "1603782833241899010",
        voucherId: "1716992627104563202",
        voucherIds: "1716992627104563202",
        wxName: "h5端用户",
        companyUrl:"",
      },
      applyDetail:undefined,
      qrcodeTimer:undefined
    };
  },
  mounted(){
    // this.countryData = JSON.parse(countryData)
    this.isApply = localStorage.getItem('isApply')?true:false
    this.applyDetail = localStorage.getItem('applyDetail')?JSON.parse(localStorage.getItem('applyDetail')):undefined
    console.log(this.applyDetail);
    if(this.applyDetail){
        this.initData()
    }
  },
  beforeDestroy(){
    clearInterval(this.qrcodeTimer)
  },
  methods: {

    initData(){
        
        let extendData = JSON.parse(this.applyDetail.extendData)
        console.log(extendData);
        this.applyStaus = this.applyDetail.usedStatus
        if(this.applyStaus==105){
            let nowTime = new Date()
            let obj = {
                timeStamp: nowTime.valueOf(),
                userid:  this.applyDetail.voucherCode
            }
            QRcode.toDataURL(JSON.stringify(obj))
                .then(url => {
                    this.qrcodeUrl = url;
                    // console.log(url);
                })
                .catch(err => {
                    // console.error(err);
                });
           this.qrcodeTimer = setInterval(() => {
              let nowTimes = new Date()
              let obj = {
                  timeStamp: nowTimes.valueOf(),
                  userid:  this.applyDetail.voucherCode
              }
              QRcode.toDataURL(JSON.stringify(obj))
                  .then(url => {
                      this.qrcodeUrl = url;
                      // console.log(url);
                  })
                  .catch(err => {
                      // console.error(err);
                  });
            }, 6000);
        }
        this.formData.dataId = this.applyDetail.dataId
        for(let i in this.mediaTypeList){
            if(this.mediaTypeList[i].id==this.applyDetail.dataId){
                this.value = this.mediaTypeList[i].text
            }
        }
        this.formData.provinceId = this.applyDetail.provinceId
        this.formData.countryId = this.applyDetail.countryId
        this.formData.cityId = this.applyDetail.cityId 
        this.formData.region = this.applyDetail.region
        this.formData.areaId = this.applyDetail.areaId  
        this.formData.location = this.applyDetail.location
        this.formData.goodName = this.applyDetail.goodName
        this.formData.idcardNumber = this.applyDetail.idCardNumber
        this.formData.companyUrl = extendData.companyUrl
        this.formData.companyPhone = extendData.companyPhone
        this.formData.company = this.applyDetail.company
        this.formData.mediaName = this.applyDetail.mediaName
        this.formData.post = extendData.post
        this.formData.email = extendData.email
        this.formData.mobile = this.applyDetail.mobile
        this.formData.facePhoto = extendData.facePhoto
        this.formData.pressCard = extendData.pressCard
        this.formData.passport = extendData.passport
        this.reason = extendData.reason
        this.formData.id = this.applyDetail.id

        // this.forEach.passport = extendData.passport

        // this.formData.countryData
        console.log(this.formData);
    },
    onChange(picker, value, index) {
      console.log(picker, value, index);
    },
    comfirm(){
        this.showTips = false
    },
    toggle(){

    },
    close(){
        this.showTips = false
    },
    async handelSubmit(){
        let param = new FormData()
        param = this.formData
        this.formData.location=this.formData.countryId==39?"1":"3"
        this.formData.idCardType=this.idCardType=="1"?true:false
        this.formData.areaId = 376;
        this.formData.pressCard = this.pressCardUrlList.join(',')
        if(this.formData.dataId==''){
            Toast('媒体类型不能为空')
            return
        }else if(this.formData.facePhoto==''){
            Toast('请上传人脸照片')
            return
        }else if(this.formData.passport==''){
            Toast('请上传证件照片')
            return
        }else if(this.formData.region==""){
            Toast('请选择地区')
            return
        }else if(this.formData.companyUrl==''){
            Toast('请填写公司网站')
            return
        }else if(this.formData.company==''){
            Toast('请填写公司名称')
            return
        }else if(this.formData.mediaName==''){
            Toast('请填写媒体名称')
            return
        }else if(this.formData.companyPhone==''){
            Toast('请填写公司联系电话')
            return
        }else if(this.formData.post==''){
            Toast('请填写职位')
            return
        }else if(this.formData.email==''){
            Toast('请填写邮箱')
            return
        }else if(this.formData.pressCard==''){
            Toast('请上传相关资料证明')
            return
        }else if(this.formData.mobile==''){
            Toast('手机号不能为空')
            return
        }
        let res1=''
        if(this.applyStaus==undefined){
            res1=await singleUserApply(param)
        }else{
            res1 = await resubmit(param)
        }
        console.log(res1);
        if(res1.errno==0){
            Toast('提交成功，请耐心等待审核')
            this.$router.push('/foreignMediaMain')
            localStorage.setItem('isApply',true)
        }
    },
    onConfirm(value) {
      this.value = value.text;
      this.showPicker = false;
      this.formData.dataId = value.id
    },
    onConfirmCountry(e){
        console.log(e);
        this.formData.region = e.text
        this.formData.provinceId = e.id
        this.formData.countryId = e.id
        this.formData.cityId = e.id
        this.showCountry = false;
    },
    afterReada(files, detail) {
      files.forEach(element => {
        // 模拟请求上传图片接口操作
        setTimeout(() => {
          element.status = null; // 上传成功后须将file对象的status属性置为null，否则遮罩不会消失。
        }, 2000);
      })

      let param = new FormData(); // 创建form对象
        param.append("file", files[0].file); // 通过append向form对象添加数据
        let config = {
            headers: { 
                "Content-Type": "multipart/form-data",
                'X-Litemall-IdentiFication': 'zhanhui',
             }
        };
        axios.post(
            this.action,
            param,
            config
        ).then(res => {
            console.log(res);
            this.formData.facePhoto = res.data.data.entity.originalUrl;
        }).catch(err => {console.log(err)})
    },
    afterReadb(files, detail) {
        let param = new FormData(); // 创建form对象
        param.append("file", files[0].file); // 通过append向form对象添加数据
        let config = {
            headers: { 
                "Content-Type": "multipart/form-data",
                'X-Litemall-IdentiFication': 'zhanhui',
             }
        };
      files.forEach(element => {
        // 模拟请求上传图片接口操作
        setTimeout(() => {
          element.status = null; // 上传成功后须将file对象的status属性置为null，否则遮罩不会消失。
        }, 2000);
      });
      axios.post(
            this.action,
            param,
            config
        ).then(async res => {
            console.log(res);
            this.formData.passport = res.data.data.entity.originalUrl;
            let res1=await checkCard({
                image:res.data.data.entity.originalUrl,
                idCardType:this.idCardType
            })
            this.formData.goodName = res1.data.entity.name;
            this.formData.idcardNumber = res1.data.entity.number;
            console.log(res1);
        }).catch(err => {console.log(err)})
    },
    afterReadc(files, detail) {
        files.forEach(element => {
        // 模拟请求上传图片接口操作
        setTimeout(() => {
          element.status = null; // 上传成功后须将file对象的status属性置为null，否则遮罩不会消失。
        }, 2000);
      })

      let param = new FormData(); // 创建form对象
        param.append("file", files[0].file); // 通过append向form对象添加数据
        let config = {
            headers: { 
                "Content-Type": "multipart/form-data",
                'X-Litemall-IdentiFication': 'zhanhui',
             }
        };
        axios.post(
            this.action,
            param,
            config
        ).then(res => {
            console.log(res);
            this.pressCardUrlList.push(res.data.data.entity.originalUrl)
            // this.formData.pressCard = res.data.data.entity.originalUrl;
        }).catch(err => {console.log(err)})

        console.log(this.pressCard);
    },
  },
};
</script>
<style lang="scss" scoped>
.apply_container {
  width: 552px;
//   min-height: 100vh;
    margin: 0 auto;
  .header_img {
    width: 100%;
    // width: 5rem;
    img {
      width: 100%;
    }
  }
  .content_wrap {
    width: 100%;
    .reson_title{
        color: red;
    }
    .form_wrap {
      width: 100%;
    //   padding: 0px 50px;
      box-sizing: border-box;
      .form_item {
        width: 100%;

        .upload_wrap {
          display: flex;
          flex-direction: column;
          .title_meia {
            color: #000;
            font-size: 65px;
            margin-bottom: 50px;
            margin-left: 60px;
            margin-top: 50px;
          }
        }
        .my-btn {
          width: 100%;
          color: #fff;
          height: 200px;
          line-height: 200px;
          font-weight: bold;
          text-align: center;
          font-size: 80px;
          background: #0283ef;
          margin-top:50px;
        }
      }
      .my_btn{
        display: flex;
        justify-content: center;
        margin: 50px 0px;
      }
    }
    .qrcode_wrap{
        .qr_name{
            font-size: 80px;
            color: #000;
            text-align: center;
        }
        .box_show{
            width: 1200px;
            height: 1200px;
            margin:200px auto;
            box-shadow: 0px 0px 30px #000;
            color: #000;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding:50px;
            >span{
                text-align: center;
                font-size: 70px;
            }
        }
    }
  }
}
.tips_wrap{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 80px;
    .desc{
        color: #000;
        display: flex;
        align-items: center;
        margin-left: 20px ;
        >span{
            margin-right: 10px;
        }
        
        >div{
            background: #E8C15F;
            color: #fff;
            padding:0px 40px;
            border-radius: 20px;
            margin-left: 30px;
            line-height: 120px;
            font-size: 70px;
        }
    }
    
}

@media screen and (min-width: 100px) and (max-width: 1000px) {
  .apply_container{
    width: 100vw;
  }
  .reson_title{
        font-size: 88px !important;
        margin:40px !important;
    }

  .box_show{

  }
}
@media screen and (min-width: 1000px) and (max-width: 2560px) {
    .apply_container {
        width: 552px;
        
    }
    .box_show{
      width: 552px !important;
      height: 552px !important;
      >span{
        font-size: 32px !important;
      }
  }
    .title_meia{
            font-size: 24px !important;
            margin:20px !important;
        }
    .reson_title{
        font-size: 28px !important;
        margin:20px !important;
    }

}



</style>

<style>
.van-cell{
    display: flex !important;
    align-items: center !important;
}
.van-radio-group{
    display: flex;
}
.van-radio{
    margin:0 50px;
}
</style>



// WEBPACK FOOTER //
// foreignMedia.vue?745bac02